import React, { useRef } from 'react';

import { Button, AvatarIcon, Menu } from '@infoods/lifebase-ui';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './UserMenu.module.scss';
import { useModalToggle } from '../../../hooks/useModalToggle';
import { loggedInUserDataStore } from '../../../stores/loggedInUserDataStore';
import {
  LogoutItem,
  ProfileItem,
  BackToHomeItem,
  GoHighLevelRefreshItem,
  PrivateModeSwitch,
} from './items';
import { getUserName } from '../../../utils/userInfoUtils';

const UserMenu = observer(() => {
  const ref = useRef<HTMLButtonElement>(null);
  const [isMenuOpen, toggleMenuOpen] = useModalToggle();

  const { loggedInUser } = loggedInUserDataStore;
  const { avatar } = loggedInUser!;

  const userName = getUserName(loggedInUser);

  return (
    <div>
      <Button
        ref={ref}
        variant="unstyled"
        onClick={toggleMenuOpen}
        startIcon={
          <AvatarIcon
            userName={userName || undefined} // update type in ui library
            className="private-info"
            avatarImgLink={avatar}
          />
        }
        endIcon={<KeyboardArrowDownRoundedIcon color="tertiary" />}
        disableRipple
      >
        <div className={classNames(classes.userName, 'private-info')}>{userName}</div>
      </Button>
      <Menu
        anchorEl={ref.current}
        open={isMenuOpen}
        onClick={toggleMenuOpen}
        variant="menu"
      >
        <PrivateModeSwitch onClick={toggleMenuOpen} />
        <ProfileItem />
        <GoHighLevelRefreshItem />
        <BackToHomeItem />
        <LogoutItem />
      </Menu>
    </div>
  );
});

export { UserMenu };
